import { defineAsyncComponent } from 'vue';

const ConvertDownloadPoup = defineAsyncComponent(() => import('@/views/convert/ConvertDownloadPoup.vue'));

const ConvertChooseDesktopDataPopup = defineAsyncComponent(() => import('@/views/convert/ConvertChooseDesktopDataPopup.vue'));

const ConvertDataPopup = defineAsyncComponent(() => import('@/views/convert/ConvertDataPopup.vue'));

const ConvertLoadingPopup = defineAsyncComponent(() => import('@/views/convert/ConvertLoadingPopup.vue'));

const ConvertDataComparePopup = defineAsyncComponent(() => import('@/views/convert/ConvertDataComparePopup.vue'));

const ConvertDataErrorPopup = defineAsyncComponent(() => import('@/views/convert/ConvertDataErrorPopup.vue'));

const ConvertConfirmPopup = defineAsyncComponent(() => import('@/views/convert/ConvertConfirmPopup.vue'));

const ErrorWarningPopup = defineAsyncComponent(() => import('@/views/convert/ErrorWarningPopup.vue'));

const ConvertAcceptPopup = defineAsyncComponent(() => import('@/views/convert/ConvertAcceptPopup.vue'));

export function registerConvert(app) {
  app.component('ConvertDownloadPoup', ConvertDownloadPoup);
  app.component('ConvertChooseDesktopDataPopup', ConvertChooseDesktopDataPopup);
  app.component('ConvertDataPopup', ConvertDataPopup);
  app.component('ConvertLoadingPopup', ConvertLoadingPopup);
  app.component('ConvertDataComparePopup', ConvertDataComparePopup);
  app.component('ConvertDataErrorPopup', ConvertDataErrorPopup);
  app.component('ConvertConfirmPopup', ConvertConfirmPopup);
  app.component('ErrorWarningPopup', ErrorWarningPopup);
  app.component('ConvertAcceptPopup', ConvertAcceptPopup);
}
